import React from 'react';

const Table = ({ columns, data, onRowClick, loading = false, emptyMessage = 'Ma jiraan' }) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-14">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-red-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-14">
        <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-slate-50 flex items-center justify-center text-2xl">🗂️</div>
        <p className="text-slate-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead>
          <tr className="bg-slate-50/80">
            {columns.map((column) => (
              <th key={column.key} className="px-5 py-3.5 text-left text-[11px] font-bold text-slate-500 uppercase tracking-wider">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={row.id || rowIndex}
              onClick={() => onRowClick && onRowClick(row)}
              className={`border-t border-slate-100 ${onRowClick ? 'cursor-pointer hover:bg-rose-50/50' : 'hover:bg-slate-50'} transition-colors`}
            >
              {columns.map((column) => (
                <td key={column.key} className="px-5 py-4 whitespace-nowrap text-sm text-slate-700">
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
